import script from "./RiskCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./RiskCategory.vue?vue&type=script&setup=true&lang=js"

import "./RiskCategory.vue?vue&type=style&index=0&id=75bcd778&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75bcd778"]])

export default __exports__